/**
 * DaGi Hair — scroll reveal animations (site-wide, subtle mode)
 */
(function () {
  const motionSetting = document.body.dataset.dagiMotion || 'subtle';
  if (motionSetting === 'off' || motionSetting === 'enhanced') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const isExcluded = (el) => {
    if (!el) return true;
    return el.closest('[data-dagi-reveal="off"]') != null;
  };

  const revealOne = (el, delayMs = 0) => {
    if (isExcluded(el)) return;
    if (delayMs > 0) {
      el.style.transitionDelay = `${delayMs}ms`;
    }
    el.classList.add('is-visible');
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const target = entry.target;

        if (target.classList.contains('dagi-reveal-group')) {
          const items = target.querySelectorAll('.dagi-reveal-item');
          if (items.length) {
            items.forEach((item, index) => {
              revealOne(item, index * 50);
            });
          } else {
            revealOne(target);
          }
        } else {
          revealOne(target);
        }

        observer.unobserve(target);
      });
    },
    { rootMargin: '0px 0px -5% 0px', threshold: 0.1 }
  );

  const observe = (selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      if (isExcluded(el)) return;
      observer.observe(el);
    });
  };

  observe('.dagi-reveal');
  observe('.dagi-reveal-group');
})();
